import { LogLevel, IPublicClientApplication, PublicClientApplication, BrowserCacheLocation, InteractionType } from '@azure/msal-browser';
import { MsalGuardConfiguration, MsalInterceptorConfiguration } from '@azure/msal-angular';
import { environment } from '../environments/environment';

export function loggerCallback(logLevel: LogLevel, message: string) {
    if (!environment.production) {
        console.log(message);
    }
}

export function MSALInstanceFactory(): IPublicClientApplication {
    const redirectUri =
        typeof window !== 'undefined'
            ? window.location.hostname === 'localhost'
                ? `${window.location.origin}/home`
                : window.location.origin
            : environment.msalConfig.auth.redirectUri;

    return new PublicClientApplication({
        auth: {
            clientId: environment.msalConfig.auth.clientId,
            authority: environment.msalConfig.auth.authority,
            redirectUri: redirectUri,
            postLogoutRedirectUri: window.location.origin
        },
        cache: {
            cacheLocation: BrowserCacheLocation.LocalStorage,
            // storeAuthStateInCookie: false, // Optional: some versions might not have this in CacheOptions
        },
        system: {
            // allowNativeBroker: false, // Disables WAM Broker (Experimental in some versions)
            loggerOptions: {
                loggerCallback,
                logLevel: environment.production ? LogLevel.Error : LogLevel.Info,
                piiLoggingEnabled: false
            }
        }
    });
}

export function MSALInterceptorConfigFactory(): MsalInterceptorConfiguration {
    const protectedResourceMap = new Map<string, Array<string>>();
    // API requests use ID token via idTokenInterceptor, not access tokens
    return {
        interactionType: InteractionType.Redirect,
        protectedResourceMap
    };
}

export function MSALGuardConfigFactory(): MsalGuardConfiguration {
    return {
        interactionType: InteractionType.Redirect,
        authRequest: {
            scopes: [...environment.apiConfig.scopes]
        },
        loginFailedRoute: '/auth-error'
    };
}
